"use strict";
// Copyright © 2021 Move Closer
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmbedPdfPartialForm = void 0;
const vue_property_decorator_1 = require("vue-property-decorator");
const backoffice_1 = require("../../../../dsl/backoffice");
const version_abstract_form_1 = require("../version.abstract.form");
let EmbedPdfPartialForm = class EmbedPdfPartialForm extends version_abstract_form_1.EmbedVersionAbstractForm {
    constructor() {
        super(...arguments);
        /**
         * Regular expression to identify file type
         *
         * NOTICE!: This regExp is very simple, so it checks presence of `.pdf` ending in the string
         *
         * @private
         */
        this.regex = /\.pdf$/;
        this.icons = backoffice_1.DashmixIconName;
    }
    /**
     * Determines whether selected file matches with constrained regex
     */
    get isPDF() {
        if (this.file.type !== 'pdf') {
            return false;
        }
        return this.file.fileUrl.match(this.regex) !== null;
    }
    /**
     * Checks if file has some key/value
     */
    get hasFile() {
        return Object.prototype.hasOwnProperty.call(this.file, 'fileDescription') ||
            Object.prototype.hasOwnProperty.call(this.file, 'type');
    }
    /**
     * Checks whether pdf related is present in `content`
     */
    get hasPdf() {
        return !!this._content.pdf && typeof this._content.pdf.value !== 'undefined';
    }
};
__decorate([
    vue_property_decorator_1.Prop({ type: Function, required: true }),
    __metadata("design:type", Function)
], EmbedPdfPartialForm.prototype, "onSelection", void 0);
__decorate([
    vue_property_decorator_1.Prop({ type: Function, required: true }),
    __metadata("design:type", Function)
], EmbedPdfPartialForm.prototype, "onRemove", void 0);
__decorate([
    vue_property_decorator_1.Prop({ type: Object, required: true, default: {} }),
    __metadata("design:type", Object)
], EmbedPdfPartialForm.prototype, "file", void 0);
EmbedPdfPartialForm = __decorate([
    vue_property_decorator_1.Component({
        name: 'EmbedPdfPartialForm',
        components: {
            DashmixButton: backoffice_1.DashmixButton,
            DashmixCheck: backoffice_1.DashmixCheck,
            DashmixInput: backoffice_1.DashmixInput
        },
        template: `
  <div class="form-group">
    <p v-if="!isPDF && hasPdf" class="py-2 m-0 font-weight-bold text-danger"> {{ $t('forms.embed.pdfFileError') }} </p>
    <p v-else class="py-2 m-0 font-weight-bold text-dark">{{ $t('forms.embed.pdfTitle') }}</p>

    <DashmixButton v-if="!hasPdf" variant="alt" :label="$t('forms.shared.search')" :icon="icons.SearchSolid" @click="onSelection" />

    <div v-if="hasPdf" class="p-3 bg-light d-flex flex-row justify-content-between align-items-center">
      {{file.fileDescription}}
      <DashmixButton :icon="icons.TrashSolid" variant="icon" theme="danger" @click="onRemove"/>
    </div>
    <!--<DashmixCheck v-if="hasPdf" class="mt-3" name="pdfAsLink" :model.sync="_content.pdfAsLink" :label="$t('forms.embed.pdfAsLink')" />-->

    <div class="form-group">
      <label for="description" class="mt-3">{{ $t('forms.embed.description') }}</label>
      <DashmixInput :model.sync="_content.description" name="description" />
    </div>
  </div>
  `
    })
], EmbedPdfPartialForm);
exports.EmbedPdfPartialForm = EmbedPdfPartialForm;
//# sourceMappingURL=EmbedPdf.form.js.map